<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Configurar Institución</v-toolbar-title>
      </v-toolbar>

      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h4>Datos Generales de la Institución</h4>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="nombre"
                prepend-icon="mdi-home"
                label="Nombre *"
                maxlength="80"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-text-field
                v-model="observaciones"
                prepend-icon="mdi-home"
                label="Descripcion de la Institución"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-text-field
                v-model="sitio"
                prepend-icon="mdi-web"
                label="Sitio Web Institucional"
                :rules="urlRules"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="celular"
                prepend-icon="mdi-cellphone"
                label="Celular"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="telefono"
                prepend-icon="mdi-phone"
                label="Telefono"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="mail"
                prepend-icon="mdi-email"
                label="E-mail"
                :rules="emailRules"
                dense
                maxlength="50"
              ></v-text-field>
            </v-col>
            <v-col cols="8" md="4" sm="4">
              <v-switch
                dense
                v-model="disponibleWeb"
                label="Habilitar Turnos Web"
              ></v-switch>
            </v-col>
            <v-col cols="8" md="4" sm="4">
              <v-switch
                dense
                v-model="notifica"
                label="Enviar Recordatorio Turnos"
              ></v-switch>
            </v-col>
            <v-col cols="8" md="4" sm="4">
              <v-switch
                dense
                v-model="vllamada"
                label="Utiliza Videoconsulta"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <h4>Dirección de la Institución en Google Maps</h4>
            </v-col>
            <v-col cols="12" class="mb-0 pb-0">
              <gmap-autocomplete
                :value="direccionString"
                class="form-control"
                style="width: 100%"
                @place_changed="setPlace"
              >
                <template v-slot:input="slotProps">
                  <v-text-field
                    prepend-icon="mdi-account"
                    label="Dirección"
                    :rules="requiredRules"
                    ref="input"
                    v-on:listeners="slotProps.listeners"
                    v-on:attrs="slotProps.attrs"
                    @keyup.enter="usePlace"
                    @blur="usePlace"
                  ></v-text-field>
                </template>
              </gmap-autocomplete>
            </v-col>
            <v-col cols="12" md="6" sm="4">
              <GmapMap
                style="width: 305px; height: 300px"
                :zoom="zoom"
                :center="center"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUI: false,
                }"
              >
                <GmapMarker
                  v-for="(marker, index) in markers"
                  :key="index"
                  :position="marker.position"
                />

                <GmapMarker
                  v-if="this.place"
                  :position="{
                    lat: this.place.geometry.location.lat(),
                    lng: this.place.geometry.location.lng(),
                  }"
                />
              </GmapMap>
            </v-col>
            <v-col cols="12" md="6" sm="4" v-if="disponibleWeb && urlPortal">
              <h3 class="mb-2">
                Portal del Paciente:
                <a
                  :href="`https://paciente.sigemed.com.ar/portal/${urlPortal}`"
                  target="_blank"
                  >https://paciente.sigemed.com.ar/portal/{{ urlPortal }}</a
                >
              </h3>
              <h3>
                Turnero sin Registro:
                <a
                  :href="`https://turnos.sigemed.com.ar/${urlPortal}`"
                  target="_blank"
                  >https://turnos.sigemed.com.ar/{{ urlPortal }}</a
                >
              </h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarDatosInstitucion"
            >Guardar</v-btn
          >
          <v-btn
            v-if="esSuperAdmin"
            color="info"
            @click.stop="abrirParametrosGenerales"
            >Parámetros Generales</v-btn
          >
          <v-btn color="error" @click.stop="salir">Salir</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <!-- Modal Parámetros Generales -->
    <v-dialog v-model="showParametrosGenerales" max-width="700" persistent>
      <v-card>
        <v-toolbar dark color="primary" dense>
          <v-toolbar-title>Parámetros Generales</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showParametrosGenerales = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.usaOdontograma" label="Usa Odontograma"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.usaVacunas" label="Usa Vacunas"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.bloqueaHC" label="Bloquea Historia Clínica"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.notificaWA" label="Notifica por WhatsApp"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model.number="parametros.tiempoRefresco" label="Tiempo Refresco (min)" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.notificaAnulacion" label="Notifica Anulación"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.incluyeAnulacionEnRecordatorio" label="Incluye Anulación en Recordatorio"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.notificaRecordatorio" label="Notifica Recordatorio"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model.number="parametros.diasNotificaWA" label="Días Notifica WA" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.esEmpresa" label="Es Empresa"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model.number="parametros.healthCenterId" label="Health Center ID" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model.number="parametros.horasBloqueoHC" label="Horas Bloqueo HC" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.usaEnvioDirecto" label="Usa Envío Directo"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.restringeHC" label="Restringe HC"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.pagoRequeridoAutoAdmision" label="Pago Requerido Auto Admisión"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model.number="parametros.tipoLlamador" label="Tipo Llamador" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.usaPrecioConsultaMasivo" label="Usa Precio Consulta Masivo"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.trackingHabilitado" label="Registrar tiempos de atención"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch dense v-model="parametros.usaInputHoraNativo" label="Usar nuevo control de hora en cronogramas"></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                dense
                v-model.number="parametros.timeoutInactividad"
                label="Tiempo de inactividad (minutos)"
                type="number"
                min="1"
                :rules="timeoutInactividadRules"
              ></v-text-field>
            </v-col>

            <!-- ===== Facturación Electrónica ARCA ===== -->
            <v-col cols="12">
              <v-divider class="my-2"></v-divider>
              <h4>Facturación Electrónica (ARCA)</h4>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model="parametros.razonSocialFiscal" label="Razón Social (fiscal)"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model="parametros.domicilioComercial" label="Domicilio Comercial"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                dense
                :items="condicionesIvaEmisor"
                item-text="texto"
                item-value="valor"
                v-model="parametros.condicionIvaEmisor"
                label="Condición frente al IVA"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                dense
                v-model.number="parametros.puntoDeVentaArca"
                label="Punto de Venta ARCA"
                type="number"
                min="1"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model="parametros.ingresosBrutos" label="Ingresos Brutos"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                dense
                v-model="parametros.fechaInicioActividades"
                label="Fecha Inicio de Actividades"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense v-model="parametros.condicionVenta" label="Condición de Venta"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="guardarParametrosGenerales">Guardar</v-btn>
          <v-btn color="error" @click="showParametrosGenerales = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../axios-auth.js";
import router from "../../router/index.js";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    emailRules: [
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
    ],
    urlRules: [
      (v) =>
        !v ||
        /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
          v,
        ) ||
        "Formato inválido",
    ],
    disponibleWeb: null,
    nombre: null,
    mail: null,
    telefono: null,
    celular: null,
    observaciones: null,
    sitio: "",
    zoom: 15,
    markers: [],
    notifica: null,
    vllamada: null,
    place: null,
    center: {
      lat: -31.65292,
      lng: -64.42826,
    },
    direccion: {
      lat: 1000,
      lng: 1000,
    },
    direccionString: null,
    urlPortal: null,
    showParametrosGenerales: false,
    parametros: {
      usaOdontograma: false,
      usaVacunas: false,
      bloqueaHC: false,
      notificaWA: false,
      tiempoRefresco: 0,
      notificaAnulacion: false,
      incluyeAnulacionEnRecordatorio: false,
      notificaRecordatorio: false,
      diasNotificaWA: null,
      esEmpresa: false,
      healthCenterId: null,
      horasBloqueoHC: null,
      usaEnvioDirecto: false,
      restringeHC: false,
      pagoRequeridoAutoAdmision: false,
      tipoLlamador: null,
      usaPrecioConsultaMasivo: false,
      trackingHabilitado: false,
      usaInputHoraNativo: false,
      timeoutInactividad: 20,
      // Facturación electrónica ARCA
      razonSocialFiscal: null,
      domicilioComercial: null,
      condicionIvaEmisor: null,
      ingresosBrutos: null,
      fechaInicioActividades: null,
      condicionVenta: null,
      puntoDeVentaArca: null,
    },
    // Códigos alineados al enum CondicionIva del backend
    // (0=ResponsableInscripto, 1=Monotributo, 2=Exento, 3=ConsumidorFinal)
    condicionesIvaEmisor: [
      { valor: 0, texto: "Responsable Inscripto" },
      { valor: 1, texto: "Responsable Monotributo" },
      { valor: 2, texto: "Exento" },
    ],
    timeoutInactividadRules: [
      (v) =>
        (v !== null && v !== undefined && v !== "") ||
        "Dato obligatorio",
      (v) =>
        Number.isInteger(Number(v)) ||
        "Debe ser un número entero",
      (v) => Number(v) > 0 || "Debe ser mayor a cero",
    ],
  }),

  mounted() {
    this.cargarDatosInstitucion();
  },
  computed: {
    esSuperAdmin() {
      const usuario = this.$store.state.usuario.usuario;
      return usuario && usuario.toLowerCase().startsWith("sigemed");
    },
  },
  methods: {
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },

    cargarDatosInstitucion() {
      const idInstitucion = this.$store.state.usuario.institucion.idInstitucion;
      let self = this;

      axios
        .get("/Usuario/BuscarDatosInstitucion?", {
          params: {
            idInstitucion: idInstitucion,
          },
        })
        .then((response) => {
          self.nombre = response.data.nombreInstitucion;
          self.observaciones = response.data.observaciones;
          self.celular = response.data.celular;
          self.telefono = response.data.telefono;
          self.mail = response.data.mail;
          self.disponibleWeb = response.data.disponibleWeb;
          self.notifica = response.data.notificaTurnos;
          self.vllamada = response.data.utilizaVideoLlamada;
          self.sitio = response.data.sitioWeb;
          self.urlPortal = response.data.urlPortalPaciente;

          if (response.data.direccion != "") {
            if (
              response.data.latitud != 1000 &&
              response.data.latitud != null
            ) {
              this.center.lat = response.data.latitud;
              this.center.lng = response.data.longitud;
              this.direccion.lat = response.data.latitud;
              this.direccion.lng = response.data.longitud;
              this.markers.push({
                position: {
                  lat: this.direccion.lat,
                  lng: this.direccion.lng,
                },
              });
            }
            //document.getElementsByClassName("pac-target-input")[0].value = response.data.direccion
            self.direccionString = response.data.direccion;
          }
        })
        .catch((error) => {});
    },
    modificarDatosInstitucion() {
      var direccion = document.getElementsByClassName("pac-target-input");

      this.$swal({
        title: "Modificar Datos Institución",
        text: "¿Desea modificar los datos de la Institución?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosInstitucion = {
            nombreInstitucion: this.nombre,
            observaciones: this.observaciones,
            direccion: direccion[0].value.toString(),
            celular: this.celular,
            telefono: this.telefono,
            mail: this.mail,
            disponibleWeb: this.disponibleWeb,
            notificaTurnos: this.notifica,
            utilizaVideoLlamada: this.vllamada,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            lat: this.direccion.lat,
            long: this.direccion.lng,
            sitioWeb: this.sitio,
          };

          let self = this;
          axios
            .get("/Usuario/ModificarInstitucion?", {
              params: {
                nombreInstitucion: datosInstitucion.nombreInstitucion,
                observaciones: datosInstitucion.observaciones,
                direccion: datosInstitucion.direccion,
                celular: datosInstitucion.celular,
                telefono: datosInstitucion.telefono,
                mail: datosInstitucion.mail,
                disponibleWeb: datosInstitucion.disponibleWeb,
                notificaTurnos: datosInstitucion.notificaTurnos,
                utilizaVideoLlamada: datosInstitucion.utilizaVideoLlamada,
                idInstitucion: datosInstitucion.idInstitucion,
                lat: datosInstitucion.lat,
                lng: datosInstitucion.long,
                sitioWeb: datosInstitucion.sitioWeb,
              },
            })
            .then((response) => {
              if (response.data != "ok") {
                self.showAlert({
                  icon: "error",
                  title: "Los datos no pudieron ser modificados",
                  vm: self,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Datos modificados exitosamente",
                  vm: self,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "Datos no modificados",
                vm: this,
              });
            });
        }
      });
    },
    salir() {
      router.push({ path: "/Home" });
    },
    abrirParametrosGenerales() {
      const idInstitucion = this.$store.state.usuario.institucion.idInstitucion;
      let self = this;
      axios
        .get("/Usuario/GetParametrosGenerales", {
          params: { idInstitucion: idInstitucion },
        })
        .then((response) => {
          self.parametros.usaOdontograma = response.data.usaOdontograma;
          self.parametros.usaVacunas = response.data.usaVacunas;
          self.parametros.bloqueaHC = response.data.bloqueaHC;
          self.parametros.notificaWA = response.data.notificaWA;
          self.parametros.tiempoRefresco = response.data.tiempoRefresco;
          self.parametros.notificaAnulacion = response.data.notificaAnulacion;
          self.parametros.incluyeAnulacionEnRecordatorio = response.data.incluyeAnulacionEnRecordatorio;
          self.parametros.notificaRecordatorio = response.data.notificaRecordatorio;
          self.parametros.diasNotificaWA = response.data.diasNotificaWA;
          self.parametros.esEmpresa = response.data.esEmpresa;
          self.parametros.healthCenterId = response.data.healthCenterId;
          self.parametros.horasBloqueoHC = response.data.horasBloqueoHC;
          self.parametros.usaEnvioDirecto = response.data.usaEnvioDirecto;
          self.parametros.restringeHC = response.data.restringeHC;
          self.parametros.pagoRequeridoAutoAdmision = response.data.pagoRequeridoAutoAdmision;
          self.parametros.tipoLlamador = response.data.tipoLlamador;
          self.parametros.usaPrecioConsultaMasivo = response.data.usaPrecioConsultaMasivo;
          self.parametros.trackingHabilitado = response.data.trackingHabilitado;
          self.parametros.usaInputHoraNativo = response.data.usaInputHoraNativo;
          self.parametros.timeoutInactividad =
            response.data.timeoutInactividad != null &&
            response.data.timeoutInactividad > 0
              ? response.data.timeoutInactividad
              : 20;
          // Facturación electrónica ARCA
          self.parametros.razonSocialFiscal = response.data.razonSocialFiscal;
          self.parametros.domicilioComercial = response.data.domicilioComercial;
          self.parametros.condicionIvaEmisor = response.data.condicionIvaEmisor;
          self.parametros.ingresosBrutos = response.data.ingresosBrutos;
          self.parametros.fechaInicioActividades = response.data.fechaInicioActividades
            ? response.data.fechaInicioActividades.substring(0, 10)
            : null;
          self.parametros.condicionVenta = response.data.condicionVenta;
          self.parametros.puntoDeVentaArca = response.data.puntoDeVentaArca;
          self.showParametrosGenerales = true;
        })
        .catch((error) => {
          self.$swal.fire({
            icon: "error",
            title: "Error al cargar parámetros generales",
            showConfirmButton: false,
            background: "#ececec",
            timer: 1500,
          });
        });
    },
    guardarParametrosGenerales() {
      const idInstitucion = this.$store.state.usuario.institucion.idInstitucion;
      let self = this;

      // Validación cliente: el tiempo de inactividad debe ser un entero mayor a cero (Req 1.5)
      const timeout = Number(self.parametros.timeoutInactividad);
      if (
        self.parametros.timeoutInactividad === null ||
        self.parametros.timeoutInactividad === undefined ||
        self.parametros.timeoutInactividad === "" ||
        !Number.isInteger(timeout) ||
        timeout <= 0
      ) {
        self.$swal.fire({
          icon: "error",
          title: "El tiempo de inactividad debe ser un número entero mayor a cero",
          showConfirmButton: false,
          background: "#ececec",
          timer: 2000,
        });
        return;
      }

      const datos = {
        idInstitucion: idInstitucion,
        usaOdontograma: self.parametros.usaOdontograma,
        usaVacunas: self.parametros.usaVacunas,
        bloqueaHC: self.parametros.bloqueaHC,
        notificaWA: self.parametros.notificaWA,
        tiempoRefresco: self.parametros.tiempoRefresco,
        notificaAnulacion: self.parametros.notificaAnulacion,
        incluyeAnulacionEnRecordatorio: self.parametros.incluyeAnulacionEnRecordatorio,
        notificaRecordatorio: self.parametros.notificaRecordatorio,
        diasNotificaWA: self.parametros.diasNotificaWA,
        esEmpresa: self.parametros.esEmpresa,
        healthCenterId: self.parametros.healthCenterId,
        horasBloqueoHC: self.parametros.horasBloqueoHC,
        usaEnvioDirecto: self.parametros.usaEnvioDirecto,
        restringeHC: self.parametros.restringeHC,
        pagoRequeridoAutoAdmision: self.parametros.pagoRequeridoAutoAdmision,
        tipoLlamador: self.parametros.tipoLlamador,
        usaPrecioConsultaMasivo: self.parametros.usaPrecioConsultaMasivo,
        trackingHabilitado: self.parametros.trackingHabilitado,
        usaInputHoraNativo: self.parametros.usaInputHoraNativo,
        timeoutInactividad: timeout,
        // Facturación electrónica ARCA
        razonSocialFiscal: self.parametros.razonSocialFiscal,
        domicilioComercial: self.parametros.domicilioComercial,
        condicionIvaEmisor: self.parametros.condicionIvaEmisor,
        ingresosBrutos: self.parametros.ingresosBrutos,
        fechaInicioActividades: self.parametros.fechaInicioActividades || null,
        condicionVenta: self.parametros.condicionVenta,
        puntoDeVentaArca: self.parametros.puntoDeVentaArca,
      };
      axios
        .post("/Usuario/GuardarParametrosGenerales", datos)
        .then((response) => {
          if (response.data === "ok") {
            self.$swal.fire({
              icon: "success",
              title: "Parámetros guardados exitosamente",
              showConfirmButton: false,
              background: "#ececec",
              timer: 1500,
            });
            self.showParametrosGenerales = false;
          } else {
            self.$swal.fire({
              icon: "error",
              title: "Error al guardar parámetros",
              showConfirmButton: false,
              background: "#ececec",
              timer: 1500,
            });
          }
        })
        .catch((error) => {
          self.$swal.fire({
            icon: "error",
            title: "Error al guardar parámetros",
            showConfirmButton: false,
            background: "#ececec",
            timer: 1500,
          });
        });
    },
    setPlace(place) {
      this.place = place;
      this.markers = null;
      this.center = {
        lat: this.place.geometry.location.lat(),
        lng: this.place.geometry.location.lng(),
      };
      this.direccion = {
        lat: this.place.geometry.location.lat(),
        lng: this.place.geometry.location.lng(),
      };
      this.direccionString = this.place.formatted_address;
    },

    usePlace(place) {
      if (this.place) {
        if (this.markers.length == 0) {
          this.markers = null;
          this.markers.push({
            position: {
              lat: this.place.geometry.location.lat(),
              lng: this.place.geometry.location.lng(),
            },
          });
        } else {
          this.markers[0].position.lat = this.place.geometry.location.lat();
          this.markers[0].position.lng = this.place.geometry.location.lng();
        }
        this.place = null;
      }
    },
  },
};
</script>
